import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();

  const services = [
    { name: language === 'tr' ? 'Web & Mobil Yazılım' : 'Web & Mobile Dev', href: '/solutions/web-app' },
    { name: language === 'tr' ? 'E-Ticaret Çözümleri' : 'E-Commerce Solutions', href: '/solutions/ecommerce' },
    { name: language === 'tr' ? 'AI & Otomasyon' : 'AI & Automation', href: '/solutions/automation' },
    { name: language === 'tr' ? 'Dijital Pazarlama' : 'Digital Marketing', href: '/solutions/marketing' }
  ];

  const company = [
    { name: language === 'tr' ? 'Hakkımızda' : 'About', href: '/about' },
    { name: language === 'tr' ? 'Referanslar' : 'References', href: '/references' },
    { name: language === 'tr' ? 'Kariyer' : 'Careers', href: '/careers' },
    { name: language === 'tr' ? 'İletişim' : 'Contact', href: '/contact' }
  ];

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">C+</span>
              </div>
              <div>
                <div className="font-bold text-lg text-gray-900 dark:text-white">Cplus Media</div>
                <div className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider">LLC</div>
              </div>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              {language === 'tr' 
                ? 'Uluslararası markalar için dijital çözümler sunan elit ajans.'
                : 'Elite agency delivering digital solutions for international brands.'}
            </p>
            <div className="flex space-x-3">
              <a href="#" className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-blue-600 hover:text-white transition-all">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-blue-600 hover:text-white transition-all">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-blue-600 hover:text-white transition-all">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-blue-600 hover:text-white transition-all">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">
              {language === 'tr' ? 'Çözümler' : 'Services'}
            </h3>
            <ul className="space-y-2">
              {services.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">
              {language === 'tr' ? 'Kurumsal' : 'Company'}
            </h3>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">
              {language === 'tr' ? 'İletişim' : 'Contact'}
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm text-gray-600 dark:text-gray-400">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>520 Robinson LN Unit 4C-15 4616 Wilmington, DE 19805 US</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-600 dark:text-gray-400">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>+1 (302) 417-2720</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-600 dark:text-gray-400">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>info@cplus.com.tr</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            © {new Date().getFullYear()} Cplus Media LLC. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
              {language === 'tr' ? 'Gizlilik' : 'Privacy'}
            </Link>
            <Link to="/terms" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
              {language === 'tr' ? 'Koşullar' : 'Terms'}
            </Link>
            <Link to="/refund" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
              {language === 'tr' ? 'İade' : 'Refund'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
